var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m32 54.57c12 0 21.9-9.38 22.54-21.36.02-.45-.25-.85-.68-1-.42-.14-.89.01-1.15.38-2.87 4.19-7.6 6.69-12.66 6.69-8.46 0-15.33-6.87-15.33-15.32 0-5.07 2.5-9.8 6.69-12.67.37-.26.52-.72.38-1.15-.14-.42-.56-.7-1-.68-11.97.64-21.35 10.54-21.35 22.54 0 12.44 10.12 22.57 22.56 22.57zm-14.24-14.31c1.9 3.17 5.73 7.19 13.2 8.33.54.09.92.6.83 1.14-.07.5-.5.85-.98.85-.05 0-.1 0-.15-.01-8.24-1.26-12.5-5.75-14.62-9.29-.28-.47-.13-1.08.35-1.37.47-.28 1.08-.13 1.37.35zm-2.79-4.4c.55-.12 1.08.22 1.2.76.01.03.08.34.26.84.18.52-.09 1.09-.61 1.28-.11.04-.22.06-.33.06-.42 0-.8-.26-.95-.67-.22-.64-.31-1.03-.32-1.07-.12-.54.22-1.08.75-1.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m10.79 61.13h42.42c4.37 0 7.92-3.55 7.92-7.92v-42.42c0-4.37-3.55-7.92-7.92-7.92h-42.42c-4.37 0-7.92 3.55-7.92 7.92v42.42c0 4.37 3.55 7.92 7.92 7.92zm-5.92-50.34c0-3.26 2.66-5.92 5.92-5.92h42.42c3.26 0 5.92 2.66 5.92 5.92v42.42c0 3.26-2.66 5.92-5.92 5.92h-42.42c-3.26 0-5.92-2.66-5.92-5.92z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.6066ef2777d3aa5cc286399d246de6d3.svg";
export { ForwardRef as ReactComponent };